export default __webpack_public_path__ + "static/media/submit.71233756.svg";